'use strict';

angular.module('login', [
    'ui.router',
]);
